import React from 'react'
import Photo from '../../Photo/Photo';
import Contacts from '../../Contacts/Contacts';
import Skills from '../../Skills/Skills';
import './Left.css';

const Left = () => {
  return (
    <div className='Left'>
      <Photo />
      <Contacts />
      <Skills />
    </div>
  )
}

export default Left